/* global pca */
define([], () => {
    "use strict";

    let addressyGlobal = pca || {};

    // pretty much ripped from vendor/pcapredict/addressy/view/base/templates/default.phtml
    addressyGlobal.on("data", function (source, key) {
        try {
            for (var c = 0; c < pca.capturePlus.controls.length; c++) {
                let cont = pca.capturePlus.controls[c];
                if (cont.key !== key) {
                    continue;
                }

                for (var f = 0; f < cont.fields.length; f++) {
                    let element = pca.getElement(cont.fields[f].element);
                    let inputEvent = new Event("input");
                    element.dispatchEvent(inputEvent);
                }
            }
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error(e);
        }
    });
});
